import { Component, inject } from "@angular/core";
import { CoreButton, CoreModalWindow, MODAL_REF, ModalRef } from "@svs/angular";
import { SettingsStore } from "../../@core/state/settings.store";
import { MarkdownComponent } from "../markdown/markdown.component";

@Component({
  selector: "app-tos-modal",
  imports: [
    MarkdownComponent,
    CoreModalWindow,
    CoreButton,
  ],
  templateUrl: "./tos-modal.component.html",
  styleUrl: "./tos-modal.component.css",
})
export class TosModalComponent {
  readonly modalRef: ModalRef = inject(MODAL_REF);
  readonly settingsStore = inject(SettingsStore);

  // TODO extract to markdown file for easier editing
  md = `Bitte beachten Sie, dass es sich beim SVS-Chatbot um ein System künstlicher Intelligenz (KI-System) handelt, das KI–Technologie zur Formulierung dynamischer Antworten benützt.

Die Beantwortung Ihrer Fragen über den SVS-Chatbot erfolgt nicht durch Mitarbeiterinnen oder Mitarbeiter der SVS und wird von diesen auch nicht überprüft.

Aus diesem Grund kann es unter Umständen zur einer nicht vollständigen bzw. für Ihr Anliegen nicht korrekten Antwort kommen, weshalb - ebenso wie für Übersetzungsfehler bei Eingaben, die nicht in deutscher Sprache erfolgen, oder von Fachbegriffen – keine Haftung übernommen werden kann.

Der SVS-Chatbot bietet eine unverbindliche Hilfestellung, welche ein individuelles Beratungsgespräch mit unseren Mitarbeiterinnen und Mitarbeiter zu Ihrem konkreten Anliegen nicht ersetzt.

Eine Rückmeldung zu Ihrer konkreten Situation und Ihren Daten kann durch den SVS-Chatbot nicht erfolgen. Aus diesem Grund weisen wir Sie ausdrücklich darauf hin, keine personenbezogenen Daten (z.B. Name, Sozialversicherungsnummer) einzugeben.

Im Rahmen der Nutzung des Chatbots verarbeiten wir Ihre IP-Adresse um die technische Funktionalität und Sicherheit zu gewährleisten sowie die Nutzung zu analysieren. Die Datenverarbeitung erfolgt auf Grundlage von Art 6 Abs 1 lit e DSGVO (Aufgabenerfüllung im öffentlichen Interesse) iVm § 7 Abs 1 SVSG (Informationstätigkeit). Die IP-Adresse wird für die Dauer von 3 Jahren gespeichert und danach gelöscht. Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung und Widerspruch zu.

Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren. In Österreich ist die Datenschutzbehörde in 1030 Wien, Barichgasse 40-42, Telefon: +43 1 52 152-0, Email: dsb@dsb.gv.at, zuständig.
`;

  acceptTos() {
    this.settingsStore.patch({tosAccepted: true});
    this.modalRef.close();
  }
}
